var Component = require("!../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  null,
  /* template */
  require("!!../../node_modules/vue-loader/lib/template-compiler?id=data-v-0429deb4!../../node_modules/vue-loader/lib/selector?type=template&index=0!./ForgetPassword.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/comman/ForgetPassword.vue
// module id = 616
// module chunks = 0